import 'i18next';
import { IsArray, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

import { TeamMemberDto } from './TeamMemberDto';

export class TeamInvitationsDto {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TeamMemberDto)
  members: TeamMemberDto[] = [];
}
